export enum Locale {
  EN_US = 'en-US',
  EN_AU = 'en-AU',
  EN_GB = 'en-GB',
}

export const extractCountryCodeFromLocale = (locale: string): string => {
  return locale.split('-')[1];
};
